interface IItemsToDisplayUpToNthOfCharsAmountParams {
  labels: string[];
  charsLimit: number;
}

export const cvsToArray = (text: string): number[] => {
  if (!text) return [];
  text = text.toString().replace(/(null|undefined)/gi, "");
  return text.split(",").filter(Boolean).map(Number);
};
/**
 * @description -This function will help you to remove all punctuation marks in Arabic and English by
 *               using this function by passing the word as argument and returning it without of punctuation
 * @param {string} word
 * @return {string} string without punctuation
 */

export const normalizeText = (word: string): string => {
  let regex = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;
  return (
    word
      .replaceAll("\u0610", "") //ARABIC SIGN SALLALLAHOU ALAYHE WA SALLAM
      .replaceAll("\u0611", "") //ARABIC SIGN ALAYHE ASSALLAM
      .replaceAll("\u0612", "") //ARABIC SIGN RAHMATULLAH ALAYHE
      .replaceAll("\u0613", "") //ARABIC SIGN RADI ALLAHOU ANHU
      .replaceAll("\u0614", "") //ARABIC SIGN TAKHALLUS

      //Remove koranic anotation
      .replaceAll("\u0615", "") //ARABIC SMALL HIGH TAH
      .replaceAll("\u0616", "") //ARABIC SMALL HIGH LIGATURE ALEF WITH LAM WITH YEH
      .replaceAll("\u0617", "") //ARABIC SMALL HIGH ZAIN
      .replaceAll("\u0618", "") //ARABIC SMALL FATHA
      .replaceAll("\u0619", "") //ARABIC SMALL DAMMA
      .replaceAll("\u061A", "") //ARABIC SMALL KASRA
      .replaceAll("\u06D6", "") //ARABIC SMALL HIGH LIGATURE SAD WITH LAM WITH ALEF MAKSURA
      .replaceAll("\u06D7", "") //ARABIC SMALL HIGH LIGATURE QAF WITH LAM WITH ALEF MAKSURA
      .replaceAll("\u06D8", "") //ARABIC SMALL HIGH MEEM INITIAL FORM
      .replaceAll("\u06D9", "") //ARABIC SMALL HIGH LAM ALEF
      .replaceAll("\u06DA", "") //ARABIC SMALL HIGH JEEM
      .replaceAll("\u06DB", "") //ARABIC SMALL HIGH THREE DOTS
      .replaceAll("\u06DC", "") //ARABIC SMALL HIGH SEEN
      .replaceAll("\u06DD", "") //ARABIC END OF AYAH
      .replaceAll("\u06DE", "") //ARABIC START OF RUB EL HIZB
      .replaceAll("\u06DF", "") //ARABIC SMALL HIGH ROUNDED ZERO
      .replaceAll("\u06E0", "") //ARABIC SMALL HIGH UPRIGHT RECTANGULAR ZERO
      .replaceAll("\u06E1", "") //ARABIC SMALL HIGH DOTLESS HEAD OF KHAH
      .replaceAll("\u06E2", "") //ARABIC SMALL HIGH MEEM ISOLATED FORM
      .replaceAll("\u06E3", "") //ARABIC SMALL LOW SEEN
      .replaceAll("\u06E4", "") //ARABIC SMALL HIGH MADDA
      .replaceAll("\u06E5", "") //ARABIC SMALL WAW
      .replaceAll("\u06E6", "") //ARABIC SMALL YEH
      .replaceAll("\u06E7", "") //ARABIC SMALL HIGH YEH
      .replaceAll("\u06E8", "") //ARABIC SMALL HIGH NOON
      .replaceAll("\u06E9", "") //ARABIC PLACE OF SAJDAH
      .replaceAll("\u06EA", "") //ARABIC EMPTY CENTRE LOW STOP
      .replaceAll("\u06EB", "") //ARABIC EMPTY CENTRE HIGH STOP
      .replaceAll("\u06EC", "") //ARABIC ROUNDED HIGH STOP WITH FILLED CENTRE
      .replaceAll("\u06ED", "") //ARABIC SMALL LOW MEEM

      //Remove tatweel
      .replaceAll("\u0640", "")

      //Remove tashkeel
      .replaceAll("\u064B", "") //ARABIC FATHATAN
      .replaceAll("\u064C", "") //ARABIC DAMMATAN
      .replaceAll("\u064D", "") //ARABIC KASRATAN
      .replaceAll("\u064E", "") //ARABIC FATHA
      .replaceAll("\u064F", "") //ARABIC DAMMA
      .replaceAll("\u0650", "") //ARABIC KASRA
      .replaceAll("\u0651", "") //ARABIC SHADDA
      .replaceAll("\u0652", "") //ARABIC SUKUN
      .replaceAll("\u0653", "") //ARABIC MADDAH ABOVE
      .replaceAll("\u0654", "") //ARABIC HAMZA ABOVE
      .replaceAll("\u0655", "") //ARABIC HAMZA BELOW
      .replaceAll("\u0656", "") //ARABIC SUBSCRIPT ALEF
      .replaceAll("\u0657", "") //ARABIC INVERTED DAMMA
      .replaceAll("\u0658", "") //ARABIC MARK NOON GHUNNA
      .replaceAll("\u0659", "") //ARABIC ZWARAKAY
      .replaceAll("\u065A", "") //ARABIC VOWEL SIGN SMALL V ABOVE
      .replaceAll("\u065B", "") //ARABIC VOWEL SIGN INVERTED SMALL V ABOVE
      .replaceAll("\u065C", "") //ARABIC VOWEL SIGN DOT BELOW
      .replaceAll("\u065D", "") //ARABIC REVERSED DAMMA
      .replaceAll("\u065E", "") //ARABIC FATHA WITH TWO DOTS
      .replaceAll("\u065F", "") //ARABIC WAVY HAMZA BELOW
      .replaceAll("\u0670", "") //ARABIC LETTER SUPERSCRIPT ALEF

      //Replace Waw Hamza Above by Waw
      .replaceAll("\u0624", "\u0648")

      //Replace Ta Marbuta by Ha
      .replaceAll("\u0629", "\u0647")

      //Replace Ya
      // and Ya Hamza Above by Alif Maksura
      .replaceAll("\u064A", "\u0649")
      .replaceAll("\u0626", "\u0649")

      // Replace Alifs with Hamza Above/Below
      // and with Madda Above by Alif
      .replaceAll("\u0622", "\u0627")
      .replaceAll("\u0623", "\u0627")
      .replaceAll("\u0625", "\u0627")
      // .replaceAll(/[0-9]/g, "")
      .replace(regex, "")
  );
};

export const isArabic = (string) => {
  var arabic = /[\u0600-\u06FF]/;
  let result = true;
  result = arabic.test(string);

  return result;
};

export const slugifyHelper = (text) => {
  if (typeof text === "object" && text && text.name) {
    text = text.name;
  }
  if (typeof text !== "string") return "";
  return text
    .toLowerCase()
    .replace(/[^0-9a-z\u0600-\u06FF]/gi, "-")
    .replace(/-{1,}/g, "-")
    .replace(/-$/, "");
};

export const itemsToDisplayUpToNthOfCharsAmount = ({
  labels,
  charsLimit,
}: IItemsToDisplayUpToNthOfCharsAmountParams) => {
  let labelsLength = 0;
  for (let i = 0; i < labels.length; i++) {
    const currentLabel = labels[i];
    const numberOfElementsToDisplay = i + 1;
    if (labelsLength + currentLabel.length > charsLimit) {
      return numberOfElementsToDisplay;
    }
    labelsLength += currentLabel.length;
  }
  return labels.length;
};

export const slimObjet = (object: any) => {
  if (!object) return object;
  const slim = (val: string) => {
    if (val.length > 100) {
      return `${val.substring(0, 90)}  .. ${val.length - 90} more`;
    }
    return val;
  };
  if (typeof object === "string") {
    return slim(object);
  }
  if (Array.isArray(object)) {
    object = object.map(slimObjet);
  } else if (typeof object === "object") {
    const object2 = { ...object };
    Object.keys(object2).forEach((k) => {
      object2[k] = slimObjet(object2[k]);
    });
    return object2;
  }

  return object;
};

export const highlightKeyword = (label: string, keyword: string) => {

  try{
    const cleanKeyword = keyword.replace(/[^\w\s]/gi, "")
    var regex = new RegExp(`${cleanKeyword}`, "gi");

    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      return label?.replace(regex, `${cleanKeyword}`);
    }else{
      return label?.replace(regex, `<strong>${cleanKeyword}</strong>`);
    }
  }
  catch(err){
    console.log("you have an error" , err)
  }

};

export const capitalize = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const capitalizeWithHighlightedKeyword = (label: string) => {
  if(label){
    let arr = label?.split("<strong>");
    if (arr && arr[0] === "") {
      arr[1] = capitalize(arr[1]);
    } else {
      arr[0] = capitalize(arr[0]);
    }
    return arr.join("<strong>");
  }

};

export const searchHighlighting = (optionLabel: string, keyword: string) => {
  return capitalizeWithHighlightedKeyword(
    highlightKeyword(optionLabel, keyword)
  );
};

export const labelHelperInternal = (
  locale: string,
  object?: any,
  specific_field: string = null
) => {
  if (typeof object === "string") return object;
  if (!object) return "";
  if (specific_field) {
    return locale === "en"
      ? object[`${specific_field}_${locale}`]
      : object[`${specific_field}_${locale}`] || object[specific_field];
  }
  return locale === "en"
    ? object.en ||
        object.option_label ||
        object.label_en ||
        object.name_en ||
        object.name_english ||
        object.title_en ||
        object.label ||
        object.name ||
        object.title ||
        object.url_en ||
        object.make_uri_en ||
        object.model_uri_en ||
        object.option_label_en ||
        ""
    : object.ar ||
        object.option_label ||
        object.label_ar ||
        object.name_ar ||
        object.name_arabic ||
        object.title_ar ||
        object.label ||
        object.name ||
        object.title ||
        object.url_ar ||
        object.make_uri_ar ||
        object.model_uri_ar ||
        object.option_label_ar ||
        "";
};